import { Component, Input } from '@angular/core';
import { FormArray, FormControl, FormGroup } from '@angular/forms';
import { MAX_BIRTH_YEAR, MIN_BIRTH_YEAR } from 'src/app/validator/birthYear.validator';

type Control = FormControl<string | null> | FormControl<number | null> | FormControl<boolean | null>;

export type InputType = 'text' | 'date' | 'number' | 'checkbox' | 'numberStepper' | 'yesNo' | 'phoneNumber' | 'select' | 'year';

const YES_NO_TRUE = 0;
const YES_NO_FALSE = 1;

const INDEX_DIFFERENCE_DISPLAY = 1;
const STARTING_YEAR = 1983;

@Component({
  selector: 'app-dynamic-input-array',
  templateUrl: './dynamic-input-array.component.html',
  styleUrls: ['./dynamic-input-array.component.scss'],
})
export class DynamicInputArrayComponent {
  @Input() formGroup!: FormGroup;
  @Input() name!: string;
  @Input() label!: string;
  @Input() inputType: InputType = 'text';
  @Input() mask?: string;
  @Input() labelArgs: Record<string, string>[] = [];

  showYearPicker: number | null = null;
  minDateYearPicker = MIN_BIRTH_YEAR;
  maxDateYearPicker = MAX_BIRTH_YEAR;

  yesNoValues = [
    { value: true, label: 'YES' },
    { value: false, label: 'NO' },
  ];

  get controls(): Control[] {
    const control = this.formGroup.controls[this.name];

    if (!control) {
      throw new Error(`Control with name ${this.name} not found`);
    }

    return (control as FormArray<Control>).controls || [control as Control];
  }

  get hasError(): boolean {
    return this.controls.some((control) => control.invalid && control.touched);
  }

  get startingYear(): number {
    return STARTING_YEAR;
  }

  getSelectedRadioButton(index: number): number {
    return this.controls[index].value ? YES_NO_TRUE : YES_NO_FALSE;
  }

  getFormControlName(index: number): string | number {
    return index;
  }

  handleRadioButtonsChange(event: number, index: number): void {
    (this.controls[index] as FormControl<boolean | null>).setValue(this.yesNoValues[event].value);
  }

  handleYearChange(event: number, index: number): void {
    (this.controls[index] as FormControl<number | null>).setValue(event);
  }

  translateArgs(index: number): Record<string, string> {
    return { ...this.labelArgs[index], index: String(index + INDEX_DIFFERENCE_DISPLAY) };
  }
}
